<ngx-smart-modal
  [title]="modalTitle"
  [identifier]="modalType"
  [closable]="true"
  [escapable]="true"
  [dismissible]="true"
  [showCloseButton]="false"
  [confirmButtonText]="confirmButtonText"
  [showConfirmButton]="false"
>
  <div class="py-3 error-message" *ngIf="selectionLimitErrorMessage">
    {{ selectionLimitErrorMessage }}
  </div>
  <div class="py-3">
    <input lib-input [formControl]="filterFormControl" type="text" placeholder="Filter by ...">
  </div>
  <div class="pt-3">
    <a href="#"
       (click)="$event.preventDefault(); addNewOption()"
       class="upload-new-file-link"
    >
      + Add Custom Reference File
    </a>
  </div>
  <ng-container *ngFor="let group of groupedOptionsToShow">
    <h4 class="options-group-header">{{ group.groupName }}</h4>
    <lib-radio-checkbox-list
      type="checkbox"
      [options]="group.options"
      [formControl]="getFormControl(group.groupName)"
      [valueProperty]="valueProperty"
      [labelProperty]="labelProperty"
    ></lib-radio-checkbox-list>
  </ng-container>
</ngx-smart-modal>
